// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vv_a bhg_b bhg_wb"};